<template>

    <div class="d-flex flex-column flex-lg-row mb-0" v-for="quota in riga.quote" v-bind:key="quota.ID_QUOTA">
        <div class="me-lg-3 mb-2 mb-lg-0">
            <img src="D:\htdocs\moonlight\UPLOAD\IMAGES\NOPHOTO\placeholder.jpg" class="squared-circle riga-quota-img-figlia" alt="">
        </div>
        <!-- DATI QUOTA PRINCIPALE -->
        <div class="flex-fill">
            <span class="text-primary fw-semibold cursor-pointer" v-on:click="openProdotto(quota)">
                <span class="d-sm-none">{{ filters.accorciaTesto(quota.DESCRIZIONE,30) }}</span>
                <span class="d-none d-md-block">{{ quota.DESCRIZIONE }}</span>
            </span>
            <span class="badge bg-dark bg-opacity-20 text-reset badge-xs">{{ filters.getLabel($root.arrayAllOpzioni,'ID_OPZIONE_TIPOLOGICA',quota.prodotto.FK_ID_TIPO,'DESCRIZIONE') }}</span>
            <span class="ms-1 me-1">|</span> 
            <!-- BOTTONE AZIONI -->
            <span class="fs-sm text-muted float-end">
                <div class="dropdown align-self-center" v-show="modalita == 2">
                    <a href="#" class="badge bg-secondary bg-opacity-20 text-secondary text-body" data-bs-toggle="dropdown" aria-expanded="false">
                        <i class="ph-list"></i>
                    </a>
                    <div class="dropdown-menu dropdown-menu-end" style="">
                        <span class="dropdown-item" v-on:click="editQuota(quota)"><i class="fad fa-pencil fa-fw me-2"></i><span class="text-muted me-1">|</span>Modifica Quota</span>
                        <span class="dropdown-item" v-on:click="editaPax(quota)"><i class="fad fa-users fa-fw me-2"></i><span class="text-muted me-1">|</span>Gestione Passeggeri</span>
                        <span class="dropdown-item" v-show="quota.FK_ID_QUOTA_PRINCIPALE == 0 || quota.FLG_EXTRA_FACOLTATIVO == 1" v-on:click="eliminaQuota(quota)"><i class="fad fa-trash text-danger fa-fw me-2"></i><span class="text-muted me-1">|</span>Elimina Quota</span>
                    </div>
                </div>
            </span>

            <p class="fs-sm mb-3 mt-0">
                <span v-if="(quota.TOT_ADU + quota.TOT_CHD + quota.TOT_INF) > 0">
                    <i class="fad fa-users fa-fw me-1"></i>{{ quota.TOT_ADU }} Adu, {{ quota.TOT_CHD }} Chd, {{ quota.TOT_INF }} Inf 
                </span>
                <span v-else class="text-danger">
                    <i class="fad fa-users fa-fw me-1"></i> Partecipanti non associati
                </span>
            </p> 


        </div>  
    </div>
   
</template>



<script>


export default {
    name:'RigaQuotaAttivita',

    emits: ['elimina', 'modifica', 'modificaDate','selezionaProdotto'],

    props:['riga','modalita'],

    components:{
    },

    data:function(){
        return {
            filters:global.filters,
        }
    },
    
    methods:{
        eliminaQuota : function(){
            this.$emit("elimina");
        },
        editQuota : function(){
            this.$emit("modifica");            
        },
        setQuotaVisibile : function(quota,flgVisibile){
            quota.FLG_VISIBILE = flgVisibile;
            utils.ajax("travel/ordine/quota/update",quota, (response) => {
                if (response.esito == 0){
                    utils.alert.success(response.messaggio);
                }
            });            
        },
        modificaDate : function(){
            this.$emit("modificaDate");            
        },
        getStileTitolo : function(){
            var stile = {};
            if (this.quota.FK_ID_QUOTA_PRINCIPALE > 0){
                stile['padding-left'] = "40px";
            }
            return stile;
        },
        getStileRiga : function(){
            var stile = {};
            if (this.quota.FK_ID_QUOTA_PRINCIPALE > 0){
                stile['font-size'] = "14px";
            }
            else{
                stile['font-size'] = "18px";
            }
            return stile;
        },
        getLblStatoQuota : function(quota){
            switch (quota.FK_ID_STATO){
                case 1:
                    return "CONFERMATA";
                case 2:
                    return "IN RICHIESTA";
                default:
                    return "-";
            }
        },
        openProdotto : function(prodotto){
            if(this.riga.FK_ID_MODULO != 6){
                this.$emit("selezionaProdotto",prodotto); 
            }
        },
        getTotaleQuote : function(quote){
            var totale = 0;
            for (var i = 0 ; i < quote.length; i++){
                totale += parseFloat(quote[i].PREZZO_TOTALE);
            }
            return totale;
        },
        getLabel : function(FK_ID_TIPO){
            const tipo = utils.array.select(this.$root.arrayAllOpzioni,"ID_OPZIONE_TIPOLOGICA",FK_ID_TIPO,1)[0];
            return tipo != undefined ? tipo.DESCRIZIONE : '';
        }
        
       
    },
    created : function(){
    }
}
</script>
